import { ITimelineItem } from '@clients/timelineClient';
import TimelineItemCard from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemCard';
import TimelineItemCashin from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemCashin';
import TimelineItemConfirmation from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemConfirmation';
import TimelineItemNoTimeline from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemNoTimeline';
import TimelineItemSkeleton from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemSkeleton';
import TimelineItemStatement from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemStatement';
import TimelineItemTransaction from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TimelineItemTransaction';

export type TimelineItemItemProps = {
    timelineItem: ITimelineItem;
    highlightOnHover?: boolean;
    panelMode?: boolean;
    showTooltip?: boolean;
};

const TimelineItemFactory = ({
    timelineItem,
    highlightOnHover = false,
    panelMode = false,
    showTooltip = false,
}: TimelineItemItemProps) => {
    switch (timelineItem?.type) {
        case 'STATEMENT':
            return (
                <TimelineItemStatement
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                    showTooltip={showTooltip}
                />
            );
        case 'TRANSACTION':
            return (
                <TimelineItemTransaction
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                    showTooltip={showTooltip}
                />
            );
        case 'CONFIRMATION':
            return (
                <TimelineItemConfirmation
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                    showTooltip={showTooltip}
                />
            );
        case 'CASHIN':
            return (
                <TimelineItemCashin
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                    showTooltip={showTooltip}
                />
            );
        case 'CARD':
            return (
                <TimelineItemCard
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                    showTooltip={showTooltip}
                />
            );
        case 'SKELETON':
            return (
                <TimelineItemSkeleton
                    timelineItem={timelineItem}
                    panelMode={panelMode}
                />
            );
        case 'NOTIMELINE':
            return (
                <TimelineItemNoTimeline
                    timelineItem={timelineItem}
                    highlightOnHover={highlightOnHover}
                    panelMode={panelMode}
                />
            );
        default:
            return null;
    }
};

export default TimelineItemFactory;
